import { css } from '@emotion/css';
import { Spacing } from 'src/styles';

export const titleContainer = css`
  p {
    ${Spacing.my0}
    ${Spacing.mx0}
  }
  ${Spacing.mb0}
`;

export const titleViewContainer = css([
  titleContainer,
  css`
    ${Spacing.mt16}
  `,
]);
